__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@customer-platform/onboarding";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "5.6.1", () => (Promise.all([__webpack_require__.e(874), __webpack_require__.e(96), __webpack_require__.e(597)]).then(() => (() => (__webpack_require__(9317))))));
			register("@customer-platform/shared", "1.0.0", () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(96), __webpack_require__.e(597), __webpack_require__.e(212), __webpack_require__.e(432)]).then(() => (() => (__webpack_require__(4432))))));
			register("antd", "5.29.3", () => (Promise.all([__webpack_require__.e(874), __webpack_require__.e(96), __webpack_require__.e(597), __webpack_require__.e(699)]).then(() => (() => (__webpack_require__(9068))))));
			register("axios", "1.15.0", () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(7340))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(96), __webpack_require__.e(597)]).then(() => (() => (__webpack_require__(3144))))));
			register("react-router-dom", "6.30.1", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(597), __webpack_require__.e(699)]).then(() => (() => (__webpack_require__(8955))))));
			register("react", "17.0.2", () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(6608))))));
			register("react", "17.0.2", () => (Promise.all([__webpack_require__.e(644), __webpack_require__.e(96)]).then(() => (() => (__webpack_require__(5517))))));
			register("react", "18.3.1", () => (__webpack_require__.e(644).then(() => (() => (__webpack_require__(4041))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(810)]).then(() => (() => (__webpack_require__(7394))))));
			register("styled-components", "6.1.19", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(597)]).then(() => (() => (__webpack_require__(275))))));
			register("sysone-api-mapper", "1.0.198", () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(517), __webpack_require__.e(791)]).then(() => (() => (__webpack_require__(9915))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};